import { FETCH_PAGED_QUANTITY_PACKS_API_COMPLETED, FETCH_PAGED_QUANTITY_PACKS_API_FAILED, FETCH_PAGED_QUANTITY_PACKS_API_STARTED, FETCH_PER_PRODUCT_PRICING_API_COMPLETED, FETCH_PER_PRODUCT_PRICING_API_FAILED, FETCH_PER_PRODUCT_PRICING_API_STARTED, PLAN_BUILDER_SYNC_CONFIGURATIONS } from '../actions/constants/ActionTypes';
const planBuilderInitialState = {
  productConfigurations: [],
  purchaseOption: undefined,
  quantityPackPurchaseOptions: [],
  isLoading: false,
  hasError: false,
  hasCommonTerms: true
};
export const planBuilder = (state = planBuilderInitialState, {
  type,
  payload
}) => {
  switch (type) {
    case FETCH_PER_PRODUCT_PRICING_API_STARTED:
      {
        return Object.assign({}, state, {
          isLoading: true
        });
      }
    case FETCH_PER_PRODUCT_PRICING_API_COMPLETED:
      {
        if (!payload) return state;
        return Object.assign({}, state, {
          purchaseOption: payload.pricingData,
          hasCommonTerms: payload.hasCommonTerms,
          isLoading: false
        });
      }
    case FETCH_PER_PRODUCT_PRICING_API_FAILED:
      {
        return Object.assign({}, state, {
          isLoading: false,
          hasError: true
        });
      }
    case FETCH_PAGED_QUANTITY_PACKS_API_STARTED:
      {
        return Object.assign({}, state, {
          isLoading: true
        });
      }
    case FETCH_PAGED_QUANTITY_PACKS_API_COMPLETED:
      {
        if (!payload) return state;
        const {
          quantityPackApiName,
          quantityPackPrice,
          skuId
        } = payload;
        const newQuantityPackPurchaseOptions = state.quantityPackPurchaseOptions.filter(option => option.quantityPackApiName !== quantityPackApiName).concat([{
          quantityPackApiName,
          skuId,
          quantityPackPrice
        }]).filter(option => {
          const isStillSelectedInProductConfigurations = state.productConfigurations.find(config => config.skuId === option.skuId);
          return isStillSelectedInProductConfigurations;
        });
        return Object.assign({}, state, {
          quantityPackPurchaseOptions: newQuantityPackPurchaseOptions,
          isLoading: false
        });
      }
    case FETCH_PAGED_QUANTITY_PACKS_API_FAILED:
      {
        return Object.assign({}, state, {
          isLoading: false,
          hasError: true
        });
      }
    case PLAN_BUILDER_SYNC_CONFIGURATIONS:
      {
        if (!payload) return state;
        const filteredQuantityPackPurchaseOptions = state.quantityPackPurchaseOptions.filter(qpPurchaseOption => payload.productConfigurations.some(({
          skuId
        }) => skuId === qpPurchaseOption.skuId));
        return Object.assign({}, state, {
          productConfigurations: payload.productConfigurations,
          quantityPackPurchaseOptions: filteredQuantityPackPurchaseOptions
        });
      }
    default:
      return state;
  }
};
export default planBuilder;